// shameless copy from GG
// import { breakLongWords } from "@/utils/breakLongWords";
import React from "react";
import ReactMarkdown from "react-markdown";
import { twMerge } from "tailwind-merge";
// breaks common Safari versions
// import rehypeRaw from "rehype-raw";
// import remarkGfm from "remark-gfm";

interface ReactMarkdownExtendedProps {
  content: string;
  enableRemark?: boolean;
  enableRehype?: boolean;
  enableClickableImages?: boolean;
  className?: string;
}

const sanitizeContent = (content: string): string => {
  content = typeof content === "string" ? content.trim() : "";
  if (!content) {
    return "";
  }

  // Break up long running character strings with the wrapping-suggestion-characters
  // content = breakLongWords(content);

  // Strip out spaces
  if (content.replaceAll) {
    return content.replaceAll("&nbsp;", "");
  } else {
    return content.replace(/&nbsp;/g, "");
  }
};

const ReactMarkdownExtended: React.FC<ReactMarkdownExtendedProps> = ({
  content,
  // enableRemark = true,
  // enableRehype = true,
  // enableClickableImages = true,
  className,
}) => {
  const sanitizedContent = sanitizeContent(content);

  // console.log("sanitizedContent", sanitizedContent);

  // const components = useMemo(() => {
  //   const result: Record<string, any> = {};

  //   if (enableClickableImages) {
  //     result.img = ({ src = "", alt = "" }) =>
  //       src ? (
  //         // eslint-disable-next-line @next/next/no-img-element
  //         <img src={src} alt={alt} className="md-scaled-image object-cover" />
  //       ) : (
  //         <span />
  //       );
  //   }

  //   return Object.keys(result).length > 0 ? result : undefined;
  // }, [enableClickableImages]);

  if (!sanitizedContent) {
    return null;
  }

  return (
    <div className={twMerge("markdown-container", className)}>
      <ReactMarkdown
      // remarkPlugins={enableRemark ? [remarkGfm] : []}
      // rehypePlugins={enableRehype ? [rehypeRaw] : []}
      // components={components}
      >
        {sanitizedContent}
      </ReactMarkdown>
    </div>
  );
};

export default ReactMarkdownExtended;
